export enum Provider {
  PiniCode = 1,
  PerfectMoney = 10000,
  Apple = 10001,
  Xbox = 10002,
  Playstation = 10003,
  Spotify = 10004,
  PayPal = 10005,
  Steam = 10006,
  Amazon = 10007,
  Skype = 10008,
  Netflix = 10009,
  Airbnb = 10010,
  Nike = 10011,
  Adidas = 10012,
  Tidal = 10013,
  GooglePlay = 10014,
  Apple_iTunes = 10015,
  Fortnite = 10016,
  Nintendo = 10017,
  Xbox_Game_Pass_Ultimate = 10018,
}

export enum ProviderType {
  Automatic = 1,
  Manual = 2,
}

export enum RequestStatus {
  New = 1,
  Pending = 10,
  Processing = 11,
  Preparing = 12,
  Done = 20,
  Failed = 21,
  Rejected = 22,
  Refund = 23,
}
